import script from "./BadgeLarge.vue?vue&type=script&setup=true&lang=js"
export * from "./BadgeLarge.vue?vue&type=script&setup=true&lang=js"

import "./BadgeLarge.vue?vue&type=style&index=0&id=c28fdf00&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c28fdf00"]])

export default __exports__